import { isEmbarcacaoComercialEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoComercial,
  EmbarcacaoComercialState,
} from "@/modules/embarcacoes/embarcacoes.types";
import { useEmbarcacaoDetailSection } from "./use-embarcacao-detail-section";
import type { EmbarcacaoDetailSectionQuery } from "./use-embarcacao-detail-section";

/** Constante de módulo: a consulta não muda entre renderizações da seção. */
const COMERCIAL_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoComercial> = {
  select: (ficha) => ficha.comercial,
  isEmpty: isEmbarcacaoComercialEmpty,
  secao: "as informações Comerciais",
};

interface UseEmbarcacaoComercialResult extends EmbarcacaoComercialState {
  reload: () => void;
}

/**
 * Consulta a seção Comercial da embarcação pedida. Somente leitura: a seção
 * não oferece nenhum recurso de escrita (AC5).
 */
export function useEmbarcacaoComercial(id: string): UseEmbarcacaoComercialResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, COMERCIAL_QUERY);

  return { ...state, comercial: data };
}
